import { appendSnsBtns } from "../functions/sns";
import { displayToTopBtn } from "../functions/guide_contents";
import { get_search_number } from "../functions/searches";
import { scrollToTop } from "../functions/others";

// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.home").length) return;
  $("#jsGetVolNum").change(() => {
    get_search_number("jsGetVolNum");
  });
  $("#jsGetJobNum").change(() => {
    get_search_number("jsGetJobNum");
  });
  $(".jsVolJobSwitch").on("click", function () {
    get_search_number(`jsGet${$(this).data("switch")}Num`);
  });

  $("#jsBackImgCarousel").slick({
    arrows: false,
    autoplay: true,
    speed: 3500,
    fade: true,
    cssEase: "linear",
    lazyLoad: "progressive",
  });
  displayToTopBtn();
  appendSnsBtns();
  scrollToTop();
});
